import * as tslib_1 from "tslib";
import React from 'react';
import TooltipPopper from './TooltipPopper';
import TooltipManager from './TooltipManager';
import s from './Tooltip.scss';
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        return (React.createElement(TooltipManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement("span", { className: s['ref-style'], ref: ref }));
            } },
            React.createElement(TooltipPopper, tslib_1.__assign({}, this.props))));
    };
    return Tooltip;
}(React.Component));
export { Tooltip };
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map